<template>
  <v-btn flat @click="$emit('click')">
    <v-layout column>
      <v-icon :color="iconColor">{{icon}}</v-icon>

      <span>{{ label }}</span>
    </v-layout>
  </v-btn>
</template>

<script>
export default {
  name: 'LToolbarButton',
  props: {
    icon: {
      type: String,
      reqiured: true
    },
    iconColor: {
      type: String
    },
    label: {
      type: String,
      reqiured: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ToolbarButton.vue